import React, {Component} from 'react';
import Spinner from 'react-spinkit';
import './loading.scss';

import style from "style";

export default class Loading extends Component {
  render = () => {
    let ret = "";
    if(this.props.finished) {
      ret = this.props.render();
    } else {
      ret = (<div className={`loading-container`}>
          <Spinner name='three-bounce' color={style.primary} />
        </div>
      );
    }
    return ret;
  }
}




// WEBPACK FOOTER //
// ./src/components/views/loading/Loading.js